module.exports = __webpack_public_path__ + "img/restart.e7e78f15.svg";